import classNames from 'classnames';
import { FC } from 'react';
import { parseMarkdown } from '../../../../../lib/markdown';

interface QuestionFieldProps {
  question: string;
  /** Statements render larger + bolder to act as section headers. */
  isStatementQuestion?: boolean;
}

const QuestionField: FC<QuestionFieldProps> = ({
  question,
  isStatementQuestion,
}) => {
  return (
    <div
      className={classNames(
        'text-body',
        isStatementQuestion
          ? 'mb-4 mt-2'
          : 'mb-3 border-b border-neutral-75 pb-1',
      )}
    >
      <div
        className="prose prose-sm max-w-none text-green-150"
        dangerouslySetInnerHTML={{ __html: parseMarkdown(question) }}
      />
    </div>
  );
};

export default QuestionField;
